import React, { useState, useEffect } from 'react';
import { withStyles } from '@mui/styles';
import ProgressBar from 'react-customizable-progressbar';
import { AUTO_LOGOUT_TIME_AFTER_MODAL_OPEN } from '../../../core/utils/Constants/Constants';
import APTimeoutProgressStyles from "./styles/APTimeoutProgress.style";
import { progressbarWorker } from '../../../core/utils/Worker/progressbarWorker';
import { workerScriptLoader } from '../../../core/utils/Worker/workerScriptLoader';

export const workerInstance = new Worker(workerScriptLoader(progressbarWorker));

function APTimeoutProgress(props: any) {
    const { classes } = props;
    const autoLogoutTime = AUTO_LOGOUT_TIME_AFTER_MODAL_OPEN;
    const totalTimeoutSeconds = Number((autoLogoutTime / 1000));
    const totalProgress = totalTimeoutSeconds > 100 ? totalTimeoutSeconds : 100;
    const secondToPercentage = Number((100 / totalTimeoutSeconds).toFixed(2));
    const [countProgress, setCountProgress] = useState<number>(0);
    const [countSeconds, setCountSeconds] = useState<number>(totalTimeoutSeconds);

    useEffect(() => {
        workerInstance.postMessage({ msg: 'start-progress' });
        workerInstance.onmessage = (message) => {
            if (message.data === 'setCountProgress-call') {
                setCountProgress((prevProgress) =>
                (prevProgress >= totalProgress ?
                    totalProgress : prevProgress + countProgress + secondToPercentage));
                setCountSeconds((prevSeconds) => (prevSeconds <= 0 ? 0 : prevSeconds - 1));
            }
        };
        return () => {
            workerInstance.postMessage({ msg: 'clear-timeout' });
        };
    }, []);

    return (
        <div className={classes.root}>
            <ProgressBar
                className={classes.loadingCircle}
                radius={100}
                progress={countProgress}
                rotate={-225}
                strokeWidth={10}
                strokeColor="#2d91e9"
                trackStrokeWidth={10}
                trackStrokeColor="#eaf3ff"
                initialAnimation={true}
                transition={"1s ease 0.5s"}
                trackTransition="0s ease"
            >
                <div className={classes.progressTimeNumber}>{countSeconds > 60 ? Number((countSeconds / 60).toFixed()) : countSeconds}</div>
                <div className={classes.progressTimeInWord}>{countSeconds > 60 ? 'Min' : 'sec'}</div>
            </ProgressBar>
        </div>
    );
}

export default withStyles(APTimeoutProgressStyles)(APTimeoutProgress);


